var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FeedbackForm',{attrs:{"loading":_vm.loading,"entry-text":_vm.entryText,"form-fields":_vm.formFields}})}
var staticRenderFns = []

export { render, staticRenderFns }